import type { Chapter } from '@/types';

export function getFirstNavigableChapter(curriculum: Chapter[]) {
  return curriculum.find((item) => item.type !== 'ChapterSection');
}

export function getFirstExercise(curriculum: Chapter[]) {
  return curriculum.find((item) => item.type === 'Exercise');
}
